import firebase from "../../firebase";
import db from "../../db";

import {
  UPDATE_INFORMATION,
  ADD_QUESTION,
  UPDATE_QUESTION,
  REMOVE_QUESTION,
  ADD_ANSWER,
  REMOVE_ANSWER,
  UPDATE_ANSWER,
  RESET_QUIZ,
  RESET_QUIZ_LIST,
  PUSH_QUIZ,
  SET_QUIZ,
  SET_CLIENT,
  SET_CLIENT_LIST
} from "./mutations";
import { Store } from "vuex";

const state = {
  newQuiz: {
    title: "New Quiz",
    description: "Quiz Name",
    questions: [
      {
        question: "First Question",
        points: 50,
        answers: [
          {
            isRight: false,
            answer: "First answer"
          },
          {
            isRight: false,
            answer: "Second answer"
          },
          {
            isRight: false,
            answer: "Third answer"
          }
        ]
      }
    ]
  },

  list: [],

  quiz: null,
  client_list: [],
  client_selection: ""
};

const getters = {
  newQuiz: ({ newQuiz }) => newQuiz,
  list: ({ list }) => list,
  quiz: ({ quiz }) => quiz,
  client_list: ({ client_list }) => client_list,
  client_selection: ({ client_selection }) => client_selection
};

const mutations = {
  [RESET_QUIZ](state) {
    state.newQuiz = {
      title: "",
      description: "",
      questions: []
    };
  },

  [UPDATE_INFORMATION](state, info) {
    state.newQuiz.title = info.title;
    state.newQuiz.description = info.description;
  },

  [ADD_QUESTION](state) {
    state.newQuiz.questions.push({
      question: "Question",
      points: 0,
      answers: []
    });
  },

  [UPDATE_QUESTION](state, payload) {
    const question = state.newQuiz.questions[payload.questionIndex];

    question.question = payload.question;
    question.points = payload.points;
  },

  [REMOVE_QUESTION](state, questionIndex) {
    if (state.newQuiz.questions.length > 1) {
      state.newQuiz.questions.splice(questionIndex, 1);
    }
  },

  [ADD_ANSWER](state, questionIndex) {
    const answers = state.newQuiz.questions[questionIndex].answers;
    if (answers.length < 5) {
      answers.push({
        answer: "Another one!",
        isRight: false
      });
    }
  },

  [UPDATE_ANSWER](state, payload) {
    const questionIndex = payload.questionIndex;
    const answerIndex = payload.answerIndex;
    const answerText = payload.answer;
    const isRight = payload.isRight;

    const answer = state.newQuiz.questions[questionIndex].answers[answerIndex];

    answer.isRight = payload.isRight;
    answer.answer = answerText;
  },

  [REMOVE_ANSWER](state, payload) {
    const questionIndex = payload.questionIndex;
    const answerIndex = payload.answerIndex;

    const question = state.newQuiz.questions[questionIndex];

    if (question.answers.length > 1) {
      question.answers.splice(answerIndex, 1);
    }
  },

  [PUSH_QUIZ](state, quiz) {
    state.list.push(quiz);
  },

  [RESET_QUIZ_LIST](state) {
    state.list = [];
  },

  [SET_QUIZ](state, quiz) {
    state.quiz = quiz;
  },
  [SET_CLIENT_LIST](state, clients) {
    state.client_list = [];
    clients.forEach((item, index) => {
      state.client_list.splice(index, 1, item);
    });
  },
  [SET_CLIENT](state, selection) {
    state.client_selection = selection;
  }
};

const actions = {
  async create({ state }) {
    console.log(
      "Running the create async ............................................."
    );
    const user = firebase.auth().currentUser;
    console.log(
      `Current user  .............................................  ${user}`
    );

    if (user) {
      const quiz = state.newQuiz;

      if (!quiz.title || !quiz.description)
        throw new Error("Quiz information is required!");

      if (quiz.questions.length == 0) throw new Error("Quiz is empty!");

      // check if there is a question without a right answer
      quiz.questions.map(question => {
        if (question.answers.length == 0) {
          throw new Error(
            `Question: '${question.question}' doesn't have answers!`
          );
        }

        let hasRightAnswer = false;

        question.answers.map(answer => {
          if (answer.isRight) hasRightAnswer = true;
        });

        if (!hasRightAnswer) {
          throw new Error(
            `Question: '${question.question}' doesn't have a right answer selected!`
          );
        }
      });

      // save to database
      console.log(
        `Saving to database  .............................................  ${user.uid}`
      );

      await db.collection(`customers/${state.client_selection}/quizzes`).add({
        ...state.newQuiz,
        userId: user.uid
      });
      alert("Quiz created");
    } else {
      alert("Unauthorized");
    }
    //db.collection('quizzes')
  },

  list({ commit }) {
    commit(RESET_QUIZ_LIST);
    if (state.client_selection) {
      db.collection(`customers/${state.client_selection}/quizzes`).onSnapshot(
        snapshot => {
          snapshot.docChanges.forEach(function(change) {
            if (change.type === "added") {
              commit(PUSH_QUIZ, {
                id: change.doc.id,
                ...change.doc.data()
              });
            }
          });
        }
      );
    }
  },

  async get({ commit }, id) {
    const quiz = await db
      .collection("quizzes")
      .doc(id)
      .get();

    if (quiz.exists) {
      commit(SET_QUIZ, {
        id: quiz.id,
        ...quiz.data()
      });
    }
  },
  async fetch_client_list({ commit }) {
    try {
      const customer_docs = await db.collection("customers").get();
      let client_list = [];
      console.log(customer_docs);
      customer_docs.forEach(doc => {
        client_list.push(doc.id);
      });
      commit(SET_CLIENT_LIST, client_list);
      console.log(client_list);
    } catch (error) {
      console.error(error);
    }
  },
  select_client({ commit }, client) {
    commit(SET_CLIENT, client);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/quiz/index.js